<div fxLayout="column" fxLayoutAlign="start stretch" class="outerwrap">
    <h1 mat-dialog-title [innerHTML]="title | safeHTML"></h1>
    <div fxFlex fxLayout="column" fxLayoutAlign="start start">
        <p [innerHTML]="message | safeHTML"></p>
        <mat-checkbox [(ngModel)]="checkboxoption" aria-label="Checkbox input option"><span [innerHTML]="checkboxlabel | safeHTML"></span></mat-checkbox>
    </div>
    <div fxLayout="row" fxLayoutAlign="end center">
        <button mat-raised-button color="warn" (click)="CancelHandler()"><span [innerHTML]="canceltext | safeHTML"></span></button>
        <button mat-raised-button color="primary" (click)="OKHandler()"><span [innerHTML]="oktext | safeHTML"></span></button>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/services/dialogs/checkbox/checkbox.dialogcomponent.html